<button
    type="button"
    class="t-prevent-parent-label-behavior"
>
    <!-- @note: this is a html huck to avoid autofocus, if the parent element is a label  -->
</button>
<ng-container *ngIf="editor.stateChange$ | async"></ng-container>
<div
    [tuiFocusable]="focusable"
    (focus)="onTopFocus()"
></div>
<div
    [tuiFocusable]="focusable"
    (focus)="onBottomFocus()"
></div>
<!-- TODO: Change to `tuiHintDescribe` when figure tuiDriver order issue -->
<section
    *ngIf="texts$ | async as texts"
    tuiToolbarNavigationManager
    class="t-tools-wrapper"
>
    <div
        *ngIf="enabled(TuiEditorTool.Undo)"
        class="t-block"
    >
        <button
            tuiItem
            tuiIconButton
            type="button"
            size="s"
            icon="tuiIconUndoLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.undo"
            [disabled]="undoDisabled"
            [focusable]="false"
            (click)="undo()"
        ></button>
        <button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconRedoLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.redo"
            [disabled]="redoDisabled"
            [focusable]="false"
            (click)="redo()"
        ></button>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Size)"
        class="t-block"
    >
        <tui-font-size
            tuiItem
            class="t-tool t-wrapper"
        ></tui-font-size>
    </div>
    <div
        *ngIf="firstBigBlockEnabled"
        class="t-block"
    >
        <tui-font-style
            *ngIf="formatEnabled"
            tuiItem
            class="t-tool t-wrapper"
            [enabledTools]="toolsSet"
        ></tui-font-style>

        <tui-align-content
            *ngIf="enabled(TuiEditorTool.Align)"
            tuiItem
            class="t-tool t-wrapper"
        ></tui-align-content>

        <tui-list-configs
            *ngIf="enabled(TuiEditorTool.List)"
            tuiItem
            class="t-tool t-wrapper"
        ></tui-list-configs>

        <button
            *ngIf="enabled(TuiEditorTool.Quote)"
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconQuoteLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.quote"
            [pseudoActive]="blockquote"
            [disabled]="unorderedList || orderedList"
            [focusable]="false"
            (click)="toggleQuote()"
        ></button>
        <tui-hosted-dropdown
            *ngIf="enabled(TuiEditorTool.Link)"
            #link
            tuiItem
            class="t-wrapper"
            [canOpen]="canOpenAnchor"
            [content]="linkDropdown"
        >
            <button
                #button
                tuiIconButton
                type="button"
                size="s"
                icon="tuiIconLinkLarge"
                appearance="icon"
                tuiHintDirection="top-left"
                tuiHintDescribe
                class="t-tool"
                [tuiHint]="texts.link"
                [pseudoActive]="link.open || a"
                [focusable]="link.open"
            ></button>
            <ng-template #linkDropdown>
                <tui-edit-link
                    #dropdown
                    (addLink)="onLink(link, $event)"
                    (removeLink)="onLink(link)"
                ></tui-edit-link>
            </ng-template>
        </tui-hosted-dropdown>
        <tui-hosted-dropdown
            *ngIf="enabled(TuiEditorTool.Anchor)"
            #anchor
            class="t-wrapper"
            [canOpen]="canOpenAnchor"
            [content]="anchorDropdown"
        >
            <button
                tuiIconButton
                type="button"
                size="s"
                icon="tuiIconAnchorLarge"
                tuiHintDirection="top-left"
                appearance="icon"
                tuiHintDescribe
                [focusable]="false"
                [pseudoActive]="anchor.open || jumpAnchor"
                [tuiHint]="texts.insertAnchor"
            ></button>
            <ng-template #anchorDropdown>
                <tui-edit-link
                    [anchorMode]="true"
                    (addLink)="setAnchor(anchor, $event)"
                    (removeLink)="removeAnchor()"
                ></tui-edit-link>
            </ng-template>
        </tui-hosted-dropdown>
        <ng-container *ngIf="enabled(TuiEditorTool.Attach)">
            <button
                #button
                tuiIconButton
                tuiItem
                type="button"
                size="s"
                icon="tuiIconPaperclipLarge"
                appearance="icon"
                tuiHintDirection="top-left"
                tuiHintDescribe
                class="t-tool t-tool_margin"
                [tuiHint]="texts.attach"
                [focusable]="false"
                (click)="fileUpload.click()"
            ></button>

            <input
                #fileUpload
                type="file"
                class="t-file-upload"
                [accept]="attachOptions.accept"
                [multiple]="attachOptions.multiple"
                [tuiFocusable]="false"
                (change)="onAttach(fileUpload)"
            />
        </ng-container>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Sub) || enabled(TuiEditorTool.Sup)"
        class="t-block"
    >
        <button
            *ngIf="enabled(TuiEditorTool.Sub)"
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconSubscriptLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.subscript"
            [pseudoActive]="subscript"
            [focusable]="false"
            (click)="toggleSubscript()"
        ></button>
        <button
            *ngIf="enabled(TuiEditorTool.Sup)"
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconSuperscriptLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.superscript"
            [pseudoActive]="superscript"
            [focusable]="false"
            (click)="toggleSuperscript()"
        ></button>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Color) || enabled(TuiEditorTool.Hilite)"
        class="t-block"
    >
        <tui-text-color
            *ngIf="enabled(TuiEditorTool.Color)"
            tuiItem
            class="t-tool t-wrapper"
            [colors]="colors"
        ></tui-text-color>

        <tui-highlight-color
            *ngIf="enabled(TuiEditorTool.Hilite)"
            tuiItem
            class="t-tool t-wrapper"
            [colors]="colors"
        ></tui-highlight-color>
    </div>
    <div
        *ngIf="secondBigBlockEnabled"
        class="t-block"
    >
        <tui-code
            *ngIf="enabled(TuiEditorTool.Code)"
            tuiItem
            class="t-tool t-wrapper"
        ></tui-code>

        <button
            *ngIf="enabled(TuiEditorTool.Tex)"
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconTeXLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool"
            [tuiHint]="texts.tex"
            [focusable]="false"
            (click)="onTeX()"
        ></button>
        <div
            *ngIf="enabled(TuiEditorTool.Img)"
            tuiItem
            class="t-wrapper"
        >
            <button
                #button
                tuiIconButton
                type="button"
                size="s"
                icon="tuiIconImageLarge"
                appearance="icon"
                tuiHintDirection="top-left"
                tuiHintDescribe
                class="t-tool"
                [tuiHint]="texts.image"
                [focusable]="false"
                (click)="image.click()"
            ></button>

            <input
                #image
                type="file"
                accept="image/*"
                class="t-image"
                [tuiFocusable]="false"
                (change)="onImage(image)"
            />
        </div>
        <button
            *ngIf="enabled(TuiEditorTool.HR)"
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconHrLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.insertHorizontalRule"
            [focusable]="false"
            (click)="insertHorizontalRule()"
        ></button>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Clear)"
        class="t-block"
    >
        <button
            #button
            tuiIconButton
            tuiItem
            type="button"
            size="s"
            icon="tuiIconClearFormatLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            class="t-tool t-tool_margin"
            [tuiHint]="texts.clear"
            [focusable]="false"
            (click)="removeFormat()"
        ></button>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Details)"
        class="t-block"
    >
        <tui-details
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-details>

        <tui-details-remove
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-details-remove>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Group)"
        class="t-block"
    >
        <tui-editor-group-tool
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-editor-group-tool>
        <tui-table-cell-color
            *ngIf="!enabled(TuiEditorTool.Table)"
            tuiItem
            class="t-tool t-wrapper"
            [colors]="colors"
        ></tui-table-cell-color>
    </div>
    <div
        *ngIf="enabled(TuiEditorTool.Table)"
        class="t-block"
    >
        <tui-table-create
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-table-create>

        <tui-table-row-column-manager
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-table-row-column-manager>

        <tui-table-merge-cells
            tuiItem
            class="t-tool t-tool_margin"
        ></tui-table-merge-cells>

        <tui-table-cell-color
            tuiItem
            class="t-tool t-wrapper"
            [colors]="colors"
        ></tui-table-cell-color>
    </div>
    <div class="t-block">
        <ng-content></ng-content>
    </div>
</section>
